module.exports = __webpack_public_path__ + "img/grey-success-wall.d77e332a.png";